import {History, LocationDescriptor} from "history";
import {
  Router,
  Route,
  RouterState,
  IndexRedirect,
} from "react-router";
import {Store} from "redux";
import {PropTypes} from "react";

import {RootState} from "./reducers";
import memoize from "./utils/memoize";

import App from "./routes";
import Login from "./routes/login";
import LoggingIn from "./routes/logging-in";
import Projects from "./routes/projects/Projects";
import Project from "./routes/projects/project/Project";
import Users from "./routes/users/Users";


type ReplaceFunc = (pathOrLoc: LocationDescriptor) => void;

function pathWithFollowup(pathname: string, nextState: RouterState) {
  return {
    pathname,
    state: {followup: nextState.location},
  };
}

const createAuthChecker = memoize((store: Store<RootState>): any => {
  return (nextState: RouterState, replace: ReplaceFunc) => {
    const state = store.getState();

    const {status} = state.iceClient;
    const permissions = state.user && state.user.permissions;

    if (status === 'logging-in' || status === 'reconnecting' ||
        (status === 'logged-in' && permissions == null)) {
      replace(pathWithFollowup('/logging-in', nextState));
      return;
    }

    if (status === 'logged-out') {
      replace(pathWithFollowup('/login', nextState));
      return;
    }
  };
});



const AppRouter = (props: {history: History},
                   context: {store: Store<RootState>}) => {
  const checkAuth = createAuthChecker(context.store);

  return <Router history={props.history}>
    <Route path="/login" component={Login}/>
    <Route path="/logging-in" component={LoggingIn}/>

    <Route path="/" component={App} onEnter={checkAuth}>
      <IndexRedirect to="projects"/>

      <Route path="projects" component={Projects}>
        <Route path=":id" component={Project}/>
      </Route>

      <Route path="users" component={Users}/>
    </Route>
  </Router>;
};

Object.assign(AppRouter, {
  contextTypes: {
    store: PropTypes.object,
  },
});

export default AppRouter;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/router.tsx